import Vue from 'vue'
import VueMask from 'v-mask'

Vue.use(VueMask)



// WEBPACK FOOTER //
// ./resources/js/plugins/v-mask.js